<ft-modal-editor-wrapper #wrapperRef [canSave]="canSave" [saveDisabled]="saveDisabled" [hasCloseButton]="hasCloseButton">
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <ng-content select="[content]"></ng-content>
    <div *ngFor="let footerControlRef of footerControlsRef" class="ft2-edit-dialog_footer-control">
        <ng-container [ngTemplateOutlet]="footerControlRef"></ng-container>
    </div>
</ft-modal-editor-wrapper>
